import 'url-search-params-polyfill';

export default function getUrlParameters() {
    return new URLSearchParams(window.location.search);
}
